import { QuoteBlock } from "graphql/generated-types";
import React from "react";

const QuoteBlock = ({ block }: { block: QuoteBlock }) => {
	const quote = block.blocks.find((block) => block.field === "quote");
	const attribution = block.blocks.find((block) => block.field === "attribution");
	return (
		<div className="container">
			<figure className="pl-5 lg:pl-8 border-l-3 border-pink">
				<blockquote className="text-lg italic lg:text-2xl">{quote?.rawValue}</blockquote>
				{attribution?.rawValue && <figcaption>- {attribution?.rawValue}</figcaption>}
			</figure>
		</div>
	);
};

export default QuoteBlock;
